import React from 'react';

const AppLoading = () => {

  return <div role="complementary" aria-label="Loading Screen" className="app app-content-container app--loading">
    <div className="loadingPage"><span>Loading ...</span></div>
  </div>;
};

export default AppLoading;
